import { Box, Sheet, Typography } from "@mui/joy";
import { TextInput } from "../../utils/input";
import { NumberInput } from "../../utils/NumberInput";

const BtsFinancialDetailsSection = ({ formData, handleInputChange, isReadOnly, sectionHeaderStyles, handleCurrencyOnBlur, approve = false }) => {

  return (
    <Sheet variant="outlined" sx={{ p: 0, borderRadius: "sm", overflow: "hidden" }}>
      <Typography level="title-lg" sx={sectionHeaderStyles} className="heading-1">
        BTS & Financial Details
      </Typography>
      <Box
        sx={{
          p: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "1fr 1fr 1fr",
            lg: "1fr 1fr 1fr 1fr",
          },
          gap: 2,
        }}
        className="add-employee-form"
      >
        {/* <TextInput name="btsNo" label="BTS No:" value={formData.btsNo} onChange={handleInputChange} disabled /> */}
        <TextInput className="disable-default" name="btsEntryDate" label="BTS Entry Date:" value={formData.btsEntryDate} onChange={handleInputChange} type="date" required readOnly disabled={isReadOnly} />
        <TextInput name="billNo" label="Invoice No.:" value={formData.billNo} onChange={(e) => {
          let str = e.target.value;
          if (str.length === 0) {
            handleInputChange(e);
          };

          const alphanumeric = /^[a-zA-Z0-9]$/;

          const firstChar = str[0];
          const lastChar = str[str.length - 1];

          if (alphanumeric.test(firstChar)) {
            handleInputChange(e);
          }

          //}

        }
        } placeholder="Enter Invoice No." required disabled={isReadOnly} maxLength={16} />
        <TextInput
          name="billDate"
          label="Invoice Date:"
          value={formData.billDate}
          onChange={handleInputChange}
          type="date"
          placeholder="dd/mm/yyyy"
          required
          disabled={isReadOnly}
        />
        <NumberInput
          name="grossAmount"
          label="Base Amount:"
          onBlur={handleCurrencyOnBlur}
          type="string"
          formatCurrency
          value={formData.grossAmount}
          onChange={handleInputChange}
          placeholder="Rupee"
          endDecorator="₹"
          required
          disabled={isReadOnly}
        />
        <NumberInput
          name="totalTax"
          label="Total Tax:"
          onBlur={handleCurrencyOnBlur}
          type="string"
          formatCurrency
          value={formData.totalTax}
          onChange={handleInputChange}
          placeholder="Enter Total Tax"
          required
          disabled={isReadOnly}
        />
        <NumberInput
          name="billAmount"
          label="Invoice Amount:"
          onBlur={handleCurrencyOnBlur}
          type="string"
          formatCurrency
          value={formData.billAmount}
          onChange={handleInputChange}
          placeholder="Rupee"
          endDecorator="₹"
          required
          disabled={isReadOnly}
        />
        {/* <NumberInput
          name="advanceAdj"
          label="Advance Adj.:"
          onBlur={handleCurrencyOnBlur}
          type="string"
          formatCurrency
          value={formData.advanceAdj}
          onChange={handleInputChange}
          placeholder="Enter Advance Adj."
          disabled={isReadOnly}
        /> */}
        <NumberInput
          name="netPayable"
          label="Net Payable:"
          onBlur={handleCurrencyOnBlur}
          type="string"
          formatCurrency
          value={formData.netPayable}
          onChange={handleInputChange}
          placeholder="Rupee"
          endDecorator="₹"
          required
          disabled={isReadOnly}
        />

        {approve && <TextInput className="disable-default" name="posting_date" label="Posting Date:" value={formData.posting_date} onChange={handleInputChange} type="date" />}
      </Box>
    </Sheet>
  );
};

export default BtsFinancialDetailsSection;
